export default __webpack_public_path__ + "static/a3326458b4c8055540d594e49450d549.png";